module.exports = __webpack_public_path__ + "img/equatorial-guinea.0c89808c.png";